var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from 'clsx';
const TagGroup = (props) => {
    const { align = 'vertical', components: { Tag }, tags, size, className } = props, rest = __rest(props, ["align", "components", "tags", "size", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('tag-group', `tag-group--align-${align}`, className) }, rest), tags.map((tag, index) => (React.createElement(Tag, Object.assign({}, tag, { key: index, size: size, className: clsx('tag-group__tag', tag.className) }))))));
};
export default TagGroup;
